export const FirebaseConfig = {
	"projectId": "bogytaxiegy",
	"appId": "1:42312458435:web:40e427a09c20f114da4276",
	"databaseURL": "https://bogytaxiegy-default-rtdb.firebaseio.com",
	"storageBucket": "bogytaxiegy.firebasestorage.app",
	"apiKey": "AIzaSyDlqzUybuZrn6J8H5ZDdnnROBXgMLhztr4",
	"authDomain": "bogytaxiegy.firebaseapp.com",
	"messagingSenderId": "42312458435",
	"measurementId": "G-8RM107N7GE"
};